<div class="modal-customized details-admin">
  <div class="modal-title">
    <h3>
      <span class="icon-view-details"></span>
      {{ this.data.modal.title }}
    </h3>
    <span class="fa fa-times modal-close" (click)="closeDialog()" data-dismiss="modal"></span>
  </div>

  <div class="modal-content">
    <div class="controls">
      <div class="to-left"><!-- Empty --></div>
      <div class="to-right">
        <!-- Search Here -->
      </div>
    </div>
    <div *ngFor="let field of data.modal.fields">
      <mat-form-field class="setup-field" appearance="outline">
        <mat-label>{{ field.title }}</mat-label>
        <input matInput placeholder="{{ field.title }}" [(ngModel)]="field.value" [disabled]="field.disabled" />
        <mat-error *ngIf="!field.value">This field is required</mat-error>
      </mat-form-field>
    </div>

    <div *ngFor="let toggle of data.modal.toggles" class="slide-div">
      <span>{{ toggle.title }}</span>
      <mat-slide-toggle class="custom-slide-toggle" [disabled]="toggle.disabled" [(ngModel)]="toggle.value"
        >ACTIVE</mat-slide-toggle
      >
    </div>
  </div>
</div>
<div class="actions">
  <div class="label-actions" mat-dialog-actions>
    <div class="creation">
      <span *ngFor="let label of data.modal.labels"
        ><i *ngIf="label.title.toLowerCase() === 'creation date'" class="icon-calendar"></i>
        <i *ngIf="label.title.toLowerCase() === 'created by'" class="icon-user"></i>{{ label.title }}:
        <b>{{ label.value }}</b></span
      >
    </div>
  </div>

  <div *ngIf="!editMode" class="btn-actions" mat-dialog-actions>
    <button
      *ngFor="let btnEdit of data.modal.button_edit"
      (click)="edit(btnEdit)"
      class="{{ btnEdit.class }}"
      mat-stroked-button
      color="primary"
    >
      <mat-icon *ngIf="btnEdit.class === 'button-edit'">edit</mat-icon> {{ btnEdit.title }}
    </button>
  </div>

  <div *ngIf="editMode" class="btn-actions" mat-dialog-actions>
    <button
      *ngFor="let btnEdit of this.action"
      (click)="actionEdit(btnEdit)"
      class="{{ btnEdit.class }}"
      mat-stroked-button
      color="primary"
    >
      {{ btnEdit.title }}
    </button>
  </div>
</div>
